module.exports = __webpack_public_path__ + "img/default-qyzc.d404d3ba.jpg";